<script setup>
    import {
        Head
    } from '@vueuse/head'
</script>
<template>

    <Head>
        <title>{{ title }}</title>
        <meta name="description" :content="description">

        <!-- Social -->
        <meta property="og:title" :content="title">
        <meta property="og:description" :content="description">
        <!-- <meta property="og:image" content="https://picsum.photos/1200/675"> -->

        <!-- Twitter -->
        <meta name="twitter:title" :content="title">
        <meta name="twitter:description" :content="description">
        <!-- <meta name="twitter:image" content="https://picsum.photos/1200/675"> -->
        <!-- <meta name="twitter:card" content="summary_large_image"> -->
    </Head>
    <section class="py-10">
        <div class="container mt-5 mt-lg-10 text-white">
            <BreadcrumbsVue>
                <template v-slot:title>
                    Experiences
                </template>
                <template v-slot:title-link>
                    Experiences
                </template>
            </BreadcrumbsVue>
            <div class="row g-1 g-lg-2 align-items-center justify-content-between mt-5">
                <div class="accordion accordion-steps bs-black" id="accordion-steps">
                    <div class="accordion-item" v-for="( works, i ) in profile.works" :key="i">
                        <h2 class="accordion-header" id="heading-steps-1">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                :data-bs-target="`#collapse-steps-${works.id}`" aria-expanded="false"
                                :aria-controls="`collapse-steps-${works.id}`">
                                 {{ works.company}}
                            </button>
                        </h2>
                        <div :id="`collapse-steps-${works.id}`" class="accordion-collapse collapse"
                            aria-labelledby="heading-steps-1" data-bs-parent="#accordion-steps">
                            <div class="accordion-body">
                                <time class="eyebrow text-muted">{{ works.year }}</time>
                                <h3>{{ works.position}}</h3>
                                <p class="text-white">{{ works.division }}</p>
                                <!-- <div class="frame">
                                <img src="assets/images/small-1.jpg" class="img-thumbnail" alt="Image">
                                <span></span>
                                :data-bs-target="`#${works.id}`"
                            </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import BreadcrumbsVue from "../components/Breadcrumbs.vue"
    //   import WorkCardVue from "../components/WorkCard.vue"
    import profile from '../../data/profile.json';
    export default {
        components: {
            BreadcrumbsVue,
            //  WorkCardVue
        },
        data: () => ({
            profile,
            title : "Experiences | Jethro Jorolan",
            description: "I'm a web developer. From Metro Manila, Philippines."
        }),
       
    }
</script>

<style>
    .accordion-steps .accordion-button:hover {
        font-weight: 500;
        line-height: 1.25;
        font-size: 3.5rem;
    }

    .accordion-steps .accordion-button[aria-expanded="true"] {
        font-weight: 500;
        line-height: 1.25;
        font-size: 3.5rem;
    }
</style>